module.exports = __webpack_public_path__ + "6a34402d8cbe7a87e9c4f8dc24b1acba.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/illustrations_03.png
// module id = 933
// module chunks = 3